import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { PriorSalesState } from '../types.ts';
import { clearOrder } from './actions/clearOrder.ts';
import { getBumpedSyncState } from './utils/getBumpedSyncState.ts';

export const initialPriorSalesState: PriorSalesState = {};

const priorSalesSlice = createSlice({
  name: 'priorSales',
  initialState: initialPriorSalesState,
  reducers: {
    setPriorSales: (state, action: PayloadAction<PriorSalesState>) => {
      Object.assign(state, {
        ...action.payload,
        syncState: getBumpedSyncState(state.syncState),
      });
    },
  },
  extraReducers: (builder) => {
    builder.addCase(clearOrder, () => initialPriorSalesState);
  },
});

export const { setPriorSales } = priorSalesSlice.actions;

export const priorSalesReducer = priorSalesSlice.reducer;
